import {useCallback, useEffect} from "react";

export default function useCustomEventListener<T>(eventName: string, handler:(data: T)=>void){
    const listener = useCallback((e)=>{
        handler(e.detail)
    },[handler])
    useEffect(() => {
        window.addEventListener(eventName, listener);
        return () => {
            window.removeEventListener(eventName, listener);
        };
    }, [eventName, listener]);
}
